"use client";

import { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";
import { useAuthStore } from "@/store";

/**
 * Route guard pra páginas autenticadas (dashboard, editar gift, etc).
 *
 * Espera o AuthSync terminar de validar o token (`hasHydrated=true`) antes
 * de decidir. Se ao final não houver usuário, redireciona pro /login
 * preservando o destino atual em `?next=...`.
 *
 * Retorna `{ user, isChecking }` — a página pode mostrar um skeleton
 * enquanto `isChecking=true`.
 */
export function useRequireAuth() {
  const router = useRouter();
  const pathname = usePathname();
  const user = useAuthStore((s) => s.user);
  const hasHydrated = useAuthStore((s) => s.hasHydrated);

  useEffect(() => {
    if (!hasHydrated) return;
    if (!user) {
      const next = encodeURIComponent(pathname || "/dashboard");
      router.replace(`/login?next=${next}`);
    }
  }, [hasHydrated, user, pathname, router]);

  return {
    user,
    isChecking: !hasHydrated,
  };
}
